import React from "react";

export const PreliquidacionContext = React.createContext();